// @flow
import Button from '@atlaskit/button';
import ExportIcon from '@atlaskit/icon/glyph/export';
import Spinner from '@atlaskit/spinner';
import formatInTimeZone from 'date-fns-tz/formatInTimeZone';
import FileSaver from 'file-saver';
import React, { FunctionComponent, useCallback, useState } from 'react';
import { withApollo, WithApolloClient } from 'react-apollo';
import styled from 'styled-components';
import { VIRTUAL_COMPONENT_RELEASES_QUERY_PAGINATED } from '../../graphql/queries';
import { analytics } from '../../services/analytics';

const StyledCsv = styled.div`
    pointer-events: 'auto';
`;

const headers = ['"Version Name"', '"Component"', '"Component Projects"', '"Start date"', '"Release date"', '"Status"'];

const convertToRowData = (componentVersion, delimiter) => {
    const projectsNames = (componentVersion?.virtualComponent?.projects || [])
        .map(({ jiraProjectName }) => jiraProjectName)
        .join(', ');
    return [
        `"${componentVersion.name}"`,
        `"${componentVersion.virtualComponent?.name || ''}"`,
        `"${projectsNames}"`,
        `"${
            componentVersion.startDate
                ? formatInTimeZone(new Date(componentVersion.startDate), 'UTC', 'MMM d, yyyy')
                : ''
        }"`,
        `"${
            componentVersion.releaseDate
                ? formatInTimeZone(new Date(`${componentVersion.releaseDate}`), 'UTC', 'MMM d, yyyy')
                : ''
        }"`,
        `"${componentVersion.isReleased ? 'Released' : 'Unreleased'}"`,
    ].join(delimiter);
};
const ExportCSVButton: FunctionComponent<WithApolloClient> = ({ client, filterVariables, delimiter = ',' }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const onClickExport = useCallback(() => {
        setLoading(true);
        client
            .query({
                query: VIRTUAL_COMPONENT_RELEASES_QUERY_PAGINATED,
                fetchPolicy: 'network-only',
                variables: {
                    ...filterVariables,
                    pagination: {},
                },
            })
            .then(({ data }) => {
                const rows = data.virtualComponentReleasesPaginated?.rows?.map((row) =>
                    convertToRowData(row, delimiter),
                );
                const content = [headers.join(delimiter), ...rows].join('\n');
                const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
                FileSaver.saveAs(blob, 'component-releases.csv');
            })
            .finally(() => setLoading(false));
        analytics.track({
            userId: window.license,
            event: 'export_csv',
            timestamp: new Date(),
            properties: {
                addon_key: process.env.REACT_APP_KEY,
            },
        });
    }, [client, delimiter, filterVariables]);
    return (
        <StyledCsv>
            <Button
                appearance="subtle"
                onClick={onClickExport}
                iconBefore={loading ? <Spinner size="small" /> : <ExportIcon label="export" />}
                isDisabled={loading}
            >
                Export
            </Button>
        </StyledCsv>
    );
};
export default withApollo(ExportCSVButton);
